import AuthGuard from '@components/AuthGuard';
import useProject from '@hooks/useProject';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import LinkContainer from './LinkContainer';
import LinkRow from './LinkRow';

function OrderContents() {
    const project = useProject();
    const { t } = useTranslation('main', { keyPrefix: 'sidebar.orders' });
    return (<LinkContainer title={t('title')}>
        {project?.features?.orderEnabled && (
            <Fragment>
                <LinkRow label={t('order')} activityName='ShopListActivity'
                    activityParams={{ isOrder: true, type: 'LIST' }} />
                <AuthGuard>
                    <LinkRow label={t('orderLogs')}
                        activityName='OrderLogsActivity'
                        activityParams={{ duration: 'WEEK' }} />
                </AuthGuard>
            </Fragment>
        )}
        {project?.features.giftEnabled && (
            <AuthGuard>
                <LinkRow label={t('gift')} activityName='GiftsActivity'
                    activityParams={{ type: 'MAIN' }} />
            </AuthGuard>
        )}
        {project?.features.ppCardEnabled && (
            <AuthGuard>
                <LinkRow label={t('prepaidCard')} activityName='MyPrepaidCardActivity'
                    activityParams={{}}/>
            </AuthGuard>
        )}
        {/*
      <AuthGuard>
          <LinkRow label='간편카드 관리' />
      </AuthGuard>
      */}
        {/*
      <AuthGuard>
          <LinkRow label='MY메뉴' activityName='MyMenuActivity'
                   activityParams={{}}/>
      </AuthGuard>
      */}
        {/*
        {project?.features.easyCardEnabled && (
            <AuthGuard>
                <LinkRow label='간편카드 관리'
                    activityName='EasyCardActivity'
                    activityParams={{}}/>
            </AuthGuard>
        )}
        */}
        <LinkRow label={t('findShop')}
            activityName='ShopListActivity'
            activityParams={{ isOrder: false, type: 'LIST' }}/>
        {import.meta.env.MODE !== 'production' && (
            <LinkRow label={t('test')} activityName='ProjectActivity'
                activityParams={{}}/>
        )}

    </LinkContainer>);
}

export default OrderContents;
